import React from 'react';
import {axios} from '../../../../services/axios';
import Papa from 'papaparse';
import {downloadCSV} from '../../../../utils/utils';
import {useSelector} from 'react-redux';
const FIELDS_TO_INCLUDE = {
    o365UserPrincipalName: 'UPN',
    displayName: 'Display Name',
    telephoneNumber: 'Telephone Number',
    dialPlan: 'Dial Plan',
    voicePolicy: 'Voice Policy',
    usageLocation: 'Usage Location',
    managedBy: 'Managed By (TCAP/Other)',
    plan: 'Plan',
    attribute1: 'Attribute 1',
    attribute2: 'Attribute 2',
    attribute3: 'Attribute 3',
};

const TEMPLATE_FILENAME = 'UsersTemplate.csv';
/**
 * handles downloading user's CSV template
 */
export default function useCSVTemplate() {
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(false);
    const [jsonData, setJSONData] = React.useState([]);
    const [template, setTemplate] = React.useState(null);

    const {currentCompany} = useSelector((state) => {
        return {...state.navigationLists};
    });
    /**
     * transforms JSON Data from BE fields into more human readable CSV heading columns
     * @param {*} data
     * @returns
     */
    const transformJSONData = (data) => {
        return data.map((user) => {
            return Object.keys(FIELDS_TO_INCLUDE).reduce((acc, key) => {
                const value = user[key];
                const newKey = FIELDS_TO_INCLUDE[key];
                acc[newKey] = value;
                if (key === 'managedBy') {
                    acc[newKey] = value === 0 ? 'TCAP' : 'Other';
                }
                if (key === 'plan') {
                    acc[newKey] = 
                        (value === null) && (acc['Telephone Number'] !== "Not Licensed") && (acc['Managed By (TCAP/Other)'] === 'TCAP') 
                        ? 'Company Default Plan' 
                        : value;
                }
                return acc;
            }, {});
        });
    };

    /**
     * handles downloading user data from BE.
     */
    const downloadUsersData = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`/users/${currentCompany}`);
            const newJSONData = transformJSONData(response.data);
            setJSONData(newJSONData);
        } catch (error) {
            setError(error);
            window.alert(
                'Could not download users data at this time. Please try again later.',
            );
        } finally {
            setLoading(false);
        }
    };

    /**
     * converts the template from JSON into CSV
     */
    const processTemplate = () => {
        const res = Papa.unparse(jsonData);
        setTemplate(res);
        downloadCSV(res, TEMPLATE_FILENAME);
    };
    /**
     * handle download template UI button
     */
    const handleDownloadTemplate = () => {
        downloadUsersData();
    };

    React.useEffect(() => {
        //after data downloaded from BE, convert to CSV
        if (jsonData.length > 0) {
            processTemplate();
        }
    }, [jsonData]);

    const {darkMode} = useSelector((state) => {
        return {...state.settings};
    });

    return {
        handleDownloadTemplate,
        loading,
        error,
        template,
    };
}
